<template>
	<div class="px-4 w-100 position-relative">
		<wrapper-mobile-view>
			<div class="w-100 bg-white py-3 px-4 border-b-semi-grey">
				<div class="w-100">
					<div class="row">
						<div class="col-1 align-self-center">
							<div @click="backTo()" class="d-inline-grid cursor-pointer">
                <img src="../../../assets/img/icon/back.png" class="mt-1" width="20">
              </div>
						</div>
						<div class="col-9 align-self-center">
							<p class="mb-0 body-1-2">{{$t('general.change-password')}}</p>
						</div>
					</div>
				</div>
			</div>
		</wrapper-mobile-view>
		<block :height="65" />
    <div class="my-4">
      <p class="mb-0 mt-4 font-regular body-2 text-color-dark">{{$t('general.current-password')}} <span class="text-danger">*</span></p>
      <input type="password" v-model="change_pass.old" class="form-control border-b-semi-grey border-bottom-green pl-3 mt-2 body-1-2 mb-0" :placeholder="$t('general.current-password')">
      <p class="mb-0 mt-4 font-regular body-2 text-color-dark">{{$t('general.new-password')}} <span class="text-danger">*</span></p>
      <input type="password" v-model="change_pass.new" class="form-control border-b-semi-grey border-bottom-green pl-3 mt-2 body-1-2 mb-0" :placeholder="$t('general.new-password')">
      <p class="mb-0 mt-4 font-regular body-2 text-color-dark">{{$t('general.confirm-new-password')}} <span class="text-danger">*</span></p>
      <input type="password" v-model="change_pass.confirm" class="form-control border-b-semi-grey border-bottom-green pl-3 mt-2 body-1-2 mb-0" :placeholder="$t('general.confirm-new-password')">
    </div>
    <div class="w-100">
    	<wrapper-mobile-view fixed_position="bottom" :space="getMerchant.merchant_type == 'restaurant' ? 74 : 0">
				<div class="px-4 pt-3 pb-4">
		    	<div v-if="change_pass.error.show" class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(255, 243, 243); border-color: rgb(254, 184, 184) !important;">
		        <p class="mb-0 body-3-1 text-capitalize">{{change_pass.error.message}}</p>
		      </div>
		      <div @click="ChangePassSubmit" class="rounded-4 px-4 button-primary w-100 text-center" :class="{'bg-green cursor-pointer': is_changepass_form_valid, 'bg-green-disabled cursor-disable' : !is_changepass_form_valid}">
		      	<pulse-loader :loading="change_pass.push_loading" v-if="change_pass.push_loading"></pulse-loader>
		        <p class="text-white body-15 text-14 mb-0 ls-1-25" v-else>{{$t('general.save-change')}}</p>
		      </div>
		    </div>
		  </wrapper-mobile-view>
    </div>
	</div>
</template>
<script>
	import {post,put} from '@/services/index.js';
	import {mapGetters} from 'vuex';
	const { email,required,sameAs } = require("vuelidate/lib/validators");
	export default{
		data(){
			return {
				change_pass:{
					old: '',
					new: '',
					confirm: '',
					error: {
						show: false,
						message: ''
					},
					push_loading: false,
				},
			}
		},
		validations: {
      change_pass: {
        old:{
         	required,
        },
        new:{
        	required,
        	sameAsPassword: sameAs('confirm')
        },
        confirm:{
        	required,
        	sameAsPassword: sameAs('new')
        }
      }
    },
		computed:{
      ...mapGetters(['getMerchant']),
			is_changepass_form_valid(){
        return (this.$v.change_pass.old.$invalid == false && this.$v.change_pass.new.$invalid == false && this.$v.change_pass.confirm.$invalid == false) ? true : false
      },
		},
    mounted(){
      this.$validateUserMenu();
    },
		methods:{
			backTo(){
				this.$emit('back')
			},
			ChangePassSubmit(){
				if (this.is_changepass_form_valid && !this.change_pass.push_loading) {
					this.change_pass.push_loading = true
					this.change_pass.error = {
						show: false,
						message: ''
					}
					let params = {
						old_password: this.change_pass.old,
						new_password: this.change_pass.new,
						re_new_password: this.change_pass.confirm
					}
					post("BASE","change-password-user",params).then(response=>{
						let res = response.data
						if (res.success) {
							this.change_pass.success = true
							this.backTo()
							this.action_success = {
								timer: 3,
								message: 'Change Password Successfully',
								show: true
							}
							this.change_pass.old = ''
							this.change_pass.new = ''
							this.change_pass.confirm = ''
						}else{
							this.change_pass.error.show = true
							this.change_pass.error.message = res.message
						}
						this.change_pass.push_loading = false
					})
				}
			},
		}
	}
</script>
<style type="text/css" scoped>
	.form-control{
  	border:none;
  	border-radius: 0!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/general/account/ChangePassword.vue